import { hasProperties } from '@gov-nx/core/types';
import { zastupujiciOsobaNazev } from '@gov-nx/module/page';
import type { RezaPermissions } from '@gov-nx/api';
import { useRezaEligibleList } from '../useRezaEligibleList';
import { getSingleRezaOptionAsText } from './utils';

interface useRezaChangeOptionsProps {
	permissions: RezaPermissions;
}

export const useRezaChangeOptions = ({
	permissions,
}: useRezaChangeOptionsProps) => {
	const isRepresentationAllowed = true;
	const { implicitAllowed, implicitFilter, explicitAllowed, explicitFilter } =
		permissions;

	const rezaList = useRezaEligibleList({
		params: { role: 'zmocnenec' },
		filter: {
			typ: explicitAllowed
				? 'explicitni'
				: implicitAllowed
					? 'implicitni'
					: undefined,
			kodSablony: implicitAllowed ? implicitFilter : explicitFilter,
		},
		enabled: implicitAllowed || explicitAllowed,
	});

	const options =
		rezaList.data?.seznam
			?.filter(hasProperties(['kod', 'nazevSablony']))
			.map((reza) => ({
				label: `${zastupujiciOsobaNazev(reza, { showIco: false })}`,
				value: reza.kod,
			})) ?? [];

	const singleOptionAsText = getSingleRezaOptionAsText(options);

	return {
		rezaList,
		options,
		singleOptionAsText,
		isRezaListLoading: rezaList.isLoading,
		isRepresentationAllowed,
		hasRepresentationOptions: options.length > 0,
		hasNoReza: options.length === 0,
	};
};

export type UseRezaChangeOptionsResult = ReturnType<
	typeof useRezaChangeOptions
>;
